import React, { useState } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import './common/App.css';
import Keycloak from 'keycloak-js';
import { KEYCLOACK_URL} from '../config/urls'
import { initializeKeycloak } from '../utils/keycloakUtils';

export default function Login({setToken}) {

	initializeKeycloak();
	
	const [mostraMensagem, setMostrarMensagem] = useState(false)
	const [mensagem, setMensagem] = useState("")

	function fecharMensagem() {
		setMostrarMensagem(false)
		return null
	}

	return (
		<div id="wrapper">
			<div id="main">
				<div className="inner">
					<header id="header">
						<link rel="preconnect" href="https://fonts.googleapis.com" />
						<link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
						<link
						rel="stylesheet"
						href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap"
						/>

						<div className="container-fluid App-header">
							<div className="row">
								<a href="/" className="logo"><img src="/distvaf/logo_fazenda_280_163.png" alt="Bem Vindo!" max-height="70%" width="auto"/></a>
							</div>
						</div>
					</header>
					<div className="container-fluid">
						<div className="row">
							
						</div>
						<div className="row">
							<div className="col-6">
							</div>
							<div className="col-6">
							</div>
						</div>
						<div className="row">
							<center>
							<div className="col-12">
								<div>
									<br></br>
									<center><h2>DISTVAF - Login</h2></center><br></br>
								</div>
								<Collapse in={mostraMensagem}>
									<Alert severity="error" action={<IconButton aria-label="close" color="inherit" size="small" onClick={() => fecharMensagem()}><CloseIcon fontSize="inherit" /></IconButton>} sx={{ mb: 2 }}>{mensagem}</Alert>
								</Collapse>
								<div className="col-4">
								</div>
							</div>
							</center>
						</div>
					</div>
					<footer id="footer">	
						<div className="container-fluid App-footer-slin">
							<p>Rodovia Papa João Paulo II, 4.001 - Prédio Gerais (6º e 7º andares) - Bairro Serra Verde, Belo Horizonte/MG CEP 31630-901</p>
						</div>
				</footer>
				</div>
			</div>			
		</div>
	)
}
